import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import theme from "../../themes";

export type BadgeType = "new" | "newUpdate" | "updateComingSoon" | "comingSoon";

const badgeColors: Record<BadgeType, { backgroundColor: string; color: string }> = {
  new: {
    backgroundColor: theme.palette.success.main,
    color: "#FFFFFF",
  },
  newUpdate: {
    backgroundColor: "#E1A731",
    color: "#FFFFFF",
  },
  updateComingSoon: {
    backgroundColor: "#E53935",
    color: "#FFFFFF",
  },
  comingSoon: {
    backgroundColor: "#E53935",
    color: "#FFFFFF",
  },
};

const badgeLabels: Record<BadgeType, string> = {
  new: "NEW",
  newUpdate: "NEW UPDATE",
  updateComingSoon: "UPDATE COMING SOON",
  comingSoon: "COMING SOON",
};

const useStyles = makeStyles(() => ({
  badge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "4px 10px",
    borderRadius: "20px",
    fontFamily: "DM Sans, sans-serif",
    fontWeight: 700,
    fontSize: "10px",
    lineHeight: "1.2",
    textTransform: "uppercase",
    marginLeft: "8px",
    whiteSpace: "nowrap",
  },
}));

interface NewBadgeProps {
  text?: string;
  badgeType?: BadgeType;
  style?: React.CSSProperties;
}

const NewBadge: React.FC<NewBadgeProps> = ({ text, badgeType = "new", style }) => {
  const classes = useStyles();
  const colors = badgeColors[badgeType];
  const label = text || badgeLabels[badgeType];

  return (
    <span
      className={classes.badge}
      style={{
        backgroundColor: colors.backgroundColor,
        color: colors.color,
        ...style,
      }}
    >
      {label}
    </span>
  );
};

export default NewBadge;
